<div class="page-layout">
  <!-- Sidebar -->
  <app-sidebar></app-sidebar>

  <!-- Main Content -->
  <main class="main-content">
    <!-- Breadcrumb -->
    <nav class="breadcrumb">
      <a href="#" class="breadcrumb-item">
        <svg viewBox="0 0 24 24" class="breadcrumb-icon">
          <path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
        </svg>
      </a>
      <span class="breadcrumb-separator">›</span>
      <a href="#" class="breadcrumb-item">Settings</a>
      <span class="breadcrumb-separator">›</span>
      <span class="breadcrumb-item active">Users</span>
    </nav>

    <!-- Page Header -->
    <header class="page-header">
      <h1 class="page-title">Users</h1>
    </header>

    <!-- Messages -->
    <div *ngIf="successMessage" class="alert alert-success">{{ successMessage }}</div>
    <div *ngIf="errorMessage" class="alert alert-error">{{ errorMessage }}</div>

    <!-- Content Card -->
    <div class="content-card">
      <!-- Table Header -->
      <div class="table-header">
        <div class="table-title-section">
          <h2 class="table-title">Users list</h2>
          <span class="badge badge-blue">{{ totalCount }}</span>
        </div>
        <div class="filters-row">
          <div class="search-box">
            <svg viewBox="0 0 24 24" class="search-icon">
              <path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
            <input
              type="text"
              placeholder="Search by name or phone"
              class="search-input"
              [(ngModel)]="searchTerm"
            />
          </div>
          <select class="form-select" [(ngModel)]="selectedRole">
            <option value="">All Roles</option>
            <option value="User">User</option>
            <option value="Manager">Manager</option>
            <option value="Owner">Owner</option>
          </select>
          <button class="btn btn-primary btn-sm" (click)="applyFilters()">Apply</button>
          <button class="btn btn-secondary btn-sm" (click)="clearFilters()">Clear</button>
        </div>
      </div>

      <!-- Table (desktop) -->
      <div class="table-container hide-mobile">
        <table class="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Role</th>
              <th>Verified</th>
              <th>Joined</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="isLoading">
              <td colspan="7" style="text-align: center; padding: 2rem;">Loading users...</td>
            </tr>
            <tr *ngIf="!isLoading && filteredUsers.length === 0">
              <td colspan="7" style="text-align: center; padding: 2rem;">No users found.</td>
            </tr>
            <tr *ngFor="let user of filteredUsers" class="table-row animate-fade-in">
              <td>
                <div class="trainer-name">{{ user.name }}</div>
              </td>
              <td>
                <span class="phone-text">{{ user.phoneNumber }}</span>
              </td>
              <td>
                <span class="specialty-text">{{ user.email || 'N/A' }}</span>
              </td>
              <td>
                <span class="role-badge" [ngClass]="getRoleBadgeClass(user.role)">{{ user.role }}</span>
              </td>
              <td>
                <span class="status-badge" [ngClass]="user.isPhoneVerified ? 'status-verified' : 'status-unverified'">
                  {{ user.isPhoneVerified ? 'Verified' : 'Unverified' }}
                </span>
              </td>
              <td>
                <span class="salary-text">{{ formatDate(user.createdAt) }}</span>
              </td>
              <td>
                <div class="action-buttons">
                  <button class="btn btn-secondary btn-sm" *ngIf="!user.isPhoneVerified" (click)="verifyUserPhone(user)">Verify</button>
                  <button class="btn btn-secondary btn-sm" (click)="openProfileModal(user)">Profile</button>
                  <button class="btn btn-secondary btn-sm" (click)="openFamilyModal(user)">Family</button>
                  <button class="btn btn-secondary btn-sm" (click)="openPasswordSidebar(user)">Password</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Mobile cards -->
      <div class="mobile-cards show-mobile">
        <div *ngIf="isLoading" style="text-align: center; padding: 2rem;">Loading users...</div>
        <div *ngIf="!isLoading && filteredUsers.length === 0" style="text-align: center; padding: 2rem;">No users found.</div>
        <div class="mobile-card animate-fade-in" *ngFor="let user of filteredUsers">
          <div class="mobile-card-header">
            <div>
              <span class="mobile-card-title">{{ user.name }}</span>
              <span class="mobile-card-subtitle">{{ user.phoneNumber }}</span>
            </div>
            <span class="role-badge" [ngClass]="getRoleBadgeClass(user.role)">{{ user.role }}</span>
          </div>
          <div class="mobile-card-body">
            <div class="mobile-card-row" *ngIf="user.email">
              <span class="mobile-card-label">Email</span>
              <span>{{ user.email }}</span>
            </div>
            <div class="mobile-card-row">
              <span class="mobile-card-label">Verified</span>
              <span class="status-badge" [ngClass]="user.isPhoneVerified ? 'status-verified' : 'status-unverified'">
                {{ user.isPhoneVerified ? 'Verified' : 'Unverified' }}
              </span>
            </div>
            <div class="mobile-card-row">
              <span class="mobile-card-label">Joined</span>
              <span>{{ formatDate(user.createdAt) }}</span>
            </div>
          </div>
          <div class="mobile-card-actions">
            <button class="btn btn-secondary btn-sm" *ngIf="!user.isPhoneVerified" (click)="verifyUserPhone(user)">Verify</button>
            <button class="btn btn-secondary btn-sm" (click)="openProfileModal(user)">Profile</button>
            <button class="btn btn-secondary btn-sm" (click)="openFamilyModal(user)">Family</button>
            <button class="btn btn-secondary btn-sm" (click)="openPasswordSidebar(user)">Password</button>
          </div>
        </div>
      </div>

      <!-- Pagination -->
      <div class="pagination" *ngIf="totalCount > 0">
        <button class="btn btn-secondary btn-sm" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
          <svg viewBox="0 0 24 24" class="btn-icon-sm">
            <path fill="currentColor" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
          </svg>
          Previous
        </button>
        <div class="pagination-numbers">
          <button
            *ngFor="let page of visiblePages"
            class="page-btn"
            [class.active]="page === currentPage"
            (click)="goToPage(page)"
          >{{ page }}</button>
        </div>
        <button class="btn btn-secondary btn-sm" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)">
          Next
          <svg viewBox="0 0 24 24" class="btn-icon-sm">
            <path fill="currentColor" d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
          </svg>
        </button>
      </div>
    </div>
  </main>
</div>

<!-- Password Update Modal -->
<div class="modal-overlay" *ngIf="showPasswordSidebar" (click)="closePasswordSidebar()">
  <div class="modal-panel" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">Update Password</h2>
      <button class="modal-close" (click)="closePasswordSidebar()">
        <svg viewBox="0 0 24 24" width="20" height="20">
          <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    </div>
    <div class="modal-body">
      <div *ngIf="selectedUser" class="user-info">
        <p><strong>User:</strong> {{ selectedUser.name }}</p>
        <p><strong>Phone:</strong> {{ selectedUser.phoneNumber }}</p>
        <p><strong>Role:</strong> {{ selectedUser.role }}</p>
      </div>
      <div *ngIf="passwordError" class="alert alert-error">{{ passwordError }}</div>
      <div class="form-group">
        <label class="form-label">New Password</label>
        <input type="password" class="form-input" placeholder="Minimum 6 characters" [(ngModel)]="newPassword" [disabled]="isUpdatingPassword"/>
      </div>
      <div class="form-group">
        <label class="form-label">Confirm Password</label>
        <input type="password" class="form-input" [(ngModel)]="confirmPassword" [disabled]="isUpdatingPassword"/>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closePasswordSidebar()" [disabled]="isUpdatingPassword">Cancel</button>
      <button class="btn btn-primary" (click)="updatePassword()" [disabled]="isUpdatingPassword || !newPassword || !confirmPassword">
        {{ isUpdatingPassword ? 'Updating...' : 'Update Password' }}
      </button>
    </div>
  </div>
</div>

<!-- Family Members Modal -->
<div class="modal-overlay" *ngIf="showFamilyModal" (click)="closeFamilyModal()">
  <div class="modal-panel modal-wide" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">Family Members — {{ familyUser?.name }}</h2>
      <button class="modal-close" (click)="closeFamilyModal()">
        <svg viewBox="0 0 24 24" width="20" height="20">
          <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    </div>
    <div class="modal-body">
      <div *ngIf="isLoadingFamily" class="loading-state">Loading family members...</div>
      <div *ngIf="familyError" class="alert alert-error">{{ familyError }}</div>
      <div *ngIf="!isLoadingFamily && !familyError && familyMembers.length === 0" class="empty-state">
        No family members added
      </div>
      <div *ngIf="!isLoadingFamily && !familyError && familyMembers.length > 0">
        <div class="family-member-card" *ngFor="let member of familyMembers">
          <div class="family-member-header">
            <div class="family-member-name">
              <strong>{{ member.name }}</strong>
              <span class="relationship-badge">{{ member.relationship }}</span>
              <span *ngIf="member.isLinked" class="linked-badge">Linked</span>
            </div>
          </div>
          <div class="family-member-details">
            <div class="detail-row" *ngIf="member.phoneNumber"><span class="detail-label">Phone:</span><span>{{ member.phoneNumber }}</span></div>
            <div class="detail-row" *ngIf="member.gender"><span class="detail-label">Gender:</span><span>{{ member.gender }}</span></div>
            <div class="detail-row" *ngIf="member.dateOfBirth"><span class="detail-label">Date of Birth:</span><span>{{ formatDate(member.dateOfBirth) }}</span></div>
            <div class="detail-row" *ngIf="member.nationalId"><span class="detail-label">National ID:</span><span>{{ member.nationalId }}</span></div>
            <div class="detail-row" *ngIf="member.weight"><span class="detail-label">Weight:</span><span>{{ member.weight }} kg</span></div>
            <div class="detail-row" *ngIf="member.height"><span class="detail-label">Height:</span><span>{{ member.height }} cm</span></div>
            <div class="detail-row" *ngIf="member.bloodType"><span class="detail-label">Blood Type:</span><span>{{ member.bloodType }}</span></div>
            <div class="detail-row" *ngIf="member.allergies"><span class="detail-label">Allergies:</span><span>{{ member.allergies }}</span></div>
            <div class="detail-row" *ngIf="member.medicalConditions"><span class="detail-label">Medical Conditions:</span><span>{{ member.medicalConditions }}</span></div>
            <div class="detail-row" *ngIf="member.medications"><span class="detail-label">Medications:</span><span>{{ member.medications }}</span></div>
            <div class="detail-row" *ngIf="member.emergencyContactName"><span class="detail-label">Emergency Contact:</span><span>{{ member.emergencyContactName }} {{ member.emergencyContactPhone ? '(' + member.emergencyContactPhone + ')' : '' }}</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeFamilyModal()">Close</button>
    </div>
  </div>
</div>

<!-- Profile Modal -->
<div class="modal-overlay" *ngIf="showProfileModal" (click)="closeProfileModal()">
  <div class="modal-panel modal-wide" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">User Profile</h2>
      <button class="modal-close" (click)="closeProfileModal()">
        <svg viewBox="0 0 24 24" width="20" height="20">
          <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    </div>
    <div class="modal-body">
      <div *ngIf="isLoadingProfile" class="loading-state">Loading profile...</div>
      <div *ngIf="profileError" class="alert alert-error">{{ profileError }}</div>

      <div *ngIf="!isLoadingProfile && !profileError">
        <h3 class="section-title">Personal Information</h3>
        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Name</label>
            <input type="text" class="form-input" [(ngModel)]="profileForm.name" [disabled]="isSavingProfile"/>
          </div>
          <div class="form-group">
            <label class="form-label">Gender</label>
            <select class="form-input" [(ngModel)]="profileForm.gender" [disabled]="isSavingProfile">
              <option [ngValue]="null">—</option>
              <option *ngFor="let g of genders" [value]="g">{{ g }}</option>
            </select>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Date of Birth</label>
            <input type="date" class="form-input" [(ngModel)]="profileForm.dateOfBirth" [disabled]="isSavingProfile"/>
          </div>
          <div class="form-group">
            <label class="form-label">National ID</label>
            <input type="text" class="form-input" [(ngModel)]="profileForm.nationalId" [disabled]="isSavingProfile"/>
          </div>
        </div>

        <h3 class="section-title">Body Measurements</h3>
        <div class="form-row form-row-3">
          <div class="form-group">
            <label class="form-label">Weight (kg)</label>
            <input type="number" class="form-input" [(ngModel)]="profileForm.weight" [disabled]="isSavingProfile"/>
          </div>
          <div class="form-group">
            <label class="form-label">Height (cm)</label>
            <input type="number" class="form-input" [(ngModel)]="profileForm.height" [disabled]="isSavingProfile"/>
          </div>
          <div class="form-group">
            <label class="form-label">Blood Type</label>
            <select class="form-input" [(ngModel)]="profileForm.bloodType" [disabled]="isSavingProfile">
              <option [ngValue]="null">—</option>
              <option *ngFor="let bt of bloodTypes" [value]="bt">{{ bt }}</option>
            </select>
          </div>
        </div>

        <h3 class="section-title">Medical Information</h3>
        <div class="form-group">
          <label class="form-label">Allergies</label>
          <textarea class="form-input" rows="2" [(ngModel)]="profileForm.allergies" [disabled]="isSavingProfile"></textarea>
        </div>
        <div class="form-group">
          <label class="form-label">Medical Conditions</label>
          <textarea class="form-input" rows="2" [(ngModel)]="profileForm.medicalConditions" [disabled]="isSavingProfile"></textarea>
        </div>
        <div class="form-group">
          <label class="form-label">Medications</label>
          <textarea class="form-input" rows="2" [(ngModel)]="profileForm.medications" [disabled]="isSavingProfile"></textarea>
        </div>

        <h3 class="section-title">Emergency Contact</h3>
        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Contact Name</label>
            <input type="text" class="form-input" [(ngModel)]="profileForm.emergencyContactName" [disabled]="isSavingProfile"/>
          </div>
          <div class="form-group">
            <label class="form-label">Contact Phone</label>
            <input type="text" class="form-input" [(ngModel)]="profileForm.emergencyContactPhone" [disabled]="isSavingProfile"/>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeProfileModal()" [disabled]="isSavingProfile">Cancel</button>
      <button class="btn btn-primary" (click)="saveProfile()" [disabled]="isSavingProfile || isLoadingProfile">
        {{ isSavingProfile ? 'Saving...' : 'Save Changes' }}
      </button>
    </div>
  </div>
</div>
